export default {
  changePopBoxStatus(context, locale) {
    context.commit('POPBOX_STATUS', locale);
  },
  changePopTranslatorStatus(context, locale) {
    context.commit('POPTRANSLATOR_STATUS', locale);
  },
  changePopNewsStatus(context, locale) {
    context.commit('POPUPGRADE_NEWS_STATUS', locale);
  },
  changePopYoutubeStatus(context, locale) {
    context.commit('POPYOUTUBE_STATUS', locale);
  },
  changePopCourseStatus(context, locale) {
    context.commit('POPCOURSE_STATUS', locale);
  },
  changePopZoomStatus(context, locale) {
    context.commit('POPZOOM_STATUS', locale);
  },
  changePopQRcodeStatus(context, locale) {
    context.commit('POPQRCODE_STATUS', locale);
  },
  changePopTeamFeatureStatus(context, locale) {
    context.commit('POPTEAM_FEATURE_STATUS', locale);
  },
  changePopDrugStatus(context, locale) {
    context.commit('POPDRUG_STATUS', locale);
  },
  // changePopShopStuffStatus(context, locale) {
  //   context.commit('POPSHOP_STUFF_STATUS', locale);
  // },
  // changePopShopBundleStatus(context, locale) {
  //   context.commit('POPSHOP_BUNDLE_STATUS', locale);
  // },
  changePopQuestionStatus(context, locale) {
    context.commit('POPQUESTION_STATUS', locale);
  },
  // changePopDeleteResumeStatus(context, locale) {
  //   context.commit('POPDELETE_RESUME_STATUS', locale);
  // },
  // changePopBlessStatus(context, locale) {
  //   context.commit('POPBLESS_STATUS', locale);
  // },
  // changePopDeleteBlessStatus(context, locale) {
  //   context.commit('POPDELETE_BLESS_STATUS', locale);
  // },
  // changePopDeleteReplyStatus(context, locale) {
  //   context.commit('POPDELETE_REPLY_STATUS', locale);
  // },
  // changePopDeleteAskStatus(context, locale) {
  //   context.commit('POPDELETE_ASK_STATUS', locale);
  // },
  changePopReportStatus(context, locale) {
    context.commit('POPREPORT_STATUS', locale);
  },
  changePopFreeTrailStatus(context, locale) {
    context.commit('POPFREETRAIL_STATUS', locale);
  },
  changePopVendorProfileStatus(context, locale) {
    context.commit('POPVENDORPROFILE_STATUS', locale);
  },
};
